<template lang="pug">
div.box
    v-server-table(
        :url="datatableUrl",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
</template>

<script>
import numeral from 'numeral';

export default {
    props: {
        payments: {
            type: Array,
            required: true,
        },
    },

    data() {
        var that = this;

        return {
            tableName: 'TRANSACTION_BREAKDOWN_DETAILS',
            columns: ['receipt_date', 'total'].concat(this.payments),
            options: {
                useReportFilter: true,
                columnsDropdown: true,
                filterable: false,
                texts: {
                    title: 'Transaction Breakdown Details',
                    description: 'Shows transaction breakdown by payment type',
                },
                pdf_url: Laroute.route(
                    'franchise.report.transaction.breakdown_details_export',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.transaction.breakdown_details_export',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.transaction.breakdown_details_export',
                    { type: 'XLSX' },
                ),
                actionButtons: [
                    {
                        title: 'Export Details',
                        action: [
                            {
                                title: 'CSV',
                                callback: () => {
                                    this.downloadExportDetails('CSV');
                                },
                            },
                            {
                                title: 'XLSX',
                                callback: () => {
                                    this.downloadExportDetails('XLSX');
                                },
                            },
                            {
                                title: 'PDF',
                                callback: () => {
                                    this.downloadExportDetails('PDF');
                                },
                            },
                        ],
                    },
                ],

                responseAdapter: res => {
                    const data = res.data.data.map(data => {
                        const paymentList = {};

                        this.payments.forEach(p => {
                            paymentList[p] = this.numberFormat(data[p]);
                        });

                        return Object.assign(
                            {
                                receipt_date: moment(data.receipt_date).format(
                                    'dddd, DD/MM/YYYY',
                                ),
                                total: this.numberFormat(data.total),
                            },
                            paymentList,
                        );
                    });

                    return {
                        data,
                        count: res.data.count,
                    };
                },
            },
        };
    },

    computed: {
        datatableUrl() {
            return Laroute.route(
                'franchise.report.transaction.breakdown_details',
            );
        },
    },

    methods: {
        numberFormat(total) {
            return numeral(total).format('0,0.00');
        },

        downloadExportDetails(type) {
            let url = Laroute.route(
                'franchise.report.transaction.transaction_breakdown_details_export',
                { type },
            );

            window.open(`${url}?${this.$refs.datatable.getQueryParams()}`);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/transaction/transaction-breakdown-details.vue